/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import StateDependencyComponent from '../../StateManager/StateDependencyComponent';
import StateEvent from '../../StateManager/StateEvent';
import { StateID } from '../../StateManager/StateID';
import StateReference from '../../StateManager/StateReference';
import AutoResizingCanvas from '../AutoResizingCanvas';
import CLog, { LogTypes } from '../ComponentLogger';
import IInjectable from './ComponentReference/IInjectable';
import InjectableComponent from './ComponentReference/InjectableComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default abstract class SwitcherComponentBase<T> extends StateDependencyComponent
{
    /** Override instance of component is injectable. */
    @property({ visible: true, override: true })
    protected _isActive: boolean = true;

    /** @hidden */
    protected canvasRef: InjectableComponent<AutoResizingCanvas> = new InjectableComponent();

    private _initState: StateReference = new StateReference(StateID.CheckRecall);

    protected items: IInjectable<T>[] = [];

    protected setContexts(): void
    {
        super.setContexts();
        this.canvasRef.SetContext(AutoResizingCanvas);
    }

    protected start(): void
    {
        super.start(this._initState);
    }

    protected onStateChangeHandler = (event: StateEvent): void =>
    {
        if (event.State === this._initState.State)
        {
            this.canvasRef.WithValue(canvas => canvas.AddOnOrientationChangeHandler(() => this.updateDisplay()),
                () => CLog.error(`No auto canvas injected.`, this, LogTypes.Initialization));
            this.updateDisplay();

            if (this.onInitState) { this.onInitState(); }
        }
    }

    protected onInitState: () => void;
    protected abstract updateDisplay(): void;

    protected forEachItem(fnEachItem: (item: T) => void): void
    {
        this.items.forEach(item => item.WithValue(value => fnEachItem(value)));
    }
}
